import ClientesComponent from "@/components/cat/clientes/ClientesComponent";
import ClienteFormComponent from "@/components/cat/clientes/ClienteFormComponent";

import SuperClienteFormComponent from "@/components/cat/super_cliente/SuperClienteFormComponent";
import SuperClientesComponent from "@/components/cat/super_cliente/SuperClientesComponent";

import UnidadesMedidasComponent from "@/components/cat/unidades_medidas/UnidadesMedidasComponent";
import UnidadesMedidasFormComponent from "@/components/cat/unidades_medidas/UnidadesMedidasFormComponent";

import TiendasComponent from "@/components/cat/tiendas/TiendasComponent";
import TiendasFormComponent from "@/components/cat/tiendas/TiendasFormComponent";

import CategoriasComponent from "@/components/cat/categorias/CategoriasComponent";
import CategoriaFormComponent from "@/components/cat/categorias/CategoriaFormComponent";

import SubCategoriasComponent from "@/components/cat/subcategorias/SubCategoriasComponent";
import SubCategoriasFormComponent from "@/components/cat/subcategorias/SubCategoriasFormComponent";

import PreciosComponent from "@/components/cat/precios/PreciosComponent";

import HabladoresHoyComponent from "@/components/cat/imprimir_habladores_hoy/HabladoresHoyComponent";

import PreciosActualizadosEnTabla from "@/components/cat/imprimir_precios_actuales_tabla/PreciosActualizadosEnTabla";

import ProductosComponent from "@/components/cat/productos/ProductosComponent";
import ProductosFormComponent from "@/components/cat/productos/ProductosFormComponent";
import ProductosPreciosComponent from "@/components/cat/productos/ProductosPreciosComponent";
import ProductosPreciosV2Component from "@/components/cat/productos/ProductosPreciosV2Component";

import ProveedorFormComponent from "@/components/cat/proveedores/ProveedorFormComponent";
import ProveedorComponent from "@/components/cat/proveedores/ProveedorComponent";

import ListaPrecioListadoComponent from "@/components/cat/lista_precios/ListaPrecioListadoComponent";
import ListaPrecioFormComponent from "@/components/cat/lista_precios/ListaPrecioFormComponent";

import EditarPreciosProductosFormComponent from "@/components/cat/lista_precios/EditarPreciosProductosFormComponent";
import ListaPrecioListadoProductosComponent from "@/components/cat/lista_precios/ListaPrecioListadoProductosComponent";

import BancosComponent from "@/components/cat/bancos/BancosComponent";
import BancosFormComponent from "@/components/cat/bancos/BancosFormComponent";

import FormaPagoComponent from "@/components/cat/forma_de_pago/FormaPagoComponent";
import FormaPagoFormComponent from "@/components/cat/forma_de_pago/FormaPagoFormComponent";

import CuentasBancariasComponent from "@/components/cat/cuentas_bancarias/CuentasBancariasComponent";
import CuentasBancariasFormComponent from "@/components/cat/cuentas_bancarias/CuentasBancariasFormComponent";

import AreaComponent from "@/components/cat/area/AreaComponent";
import AreaFormComponent from "@/components/cat/area/AreaFormComponent";

import CentroCostoComponent from "@/components/cat/centro_costo/CentroCostoComponent";
import CentroCostoFormComponent from "@/components/cat/centro_costo/CentroCostoFormComponent";

import TiendaBodegaComponent from "@/components/cat/tienda_bodega/TiendaBodegaComponent";
import TiendaBodegaFormComponent from "@/components/cat/tienda_bodega/TiendaBodegaFormComponent";

import PosicionesComponents from "@/components/cat/posiciones/PosicionesComponents";

import EscalasComponent from "@/components/cat/escalas/EscalasComponent";
import EscalasFormComponent from "@/components/cat/escalas/EscalasFormComponent";

import ExtensionesReportComponent from "@/components/commons/ExtensionesReportComponent";

import CuponesAplComponent from "@/components/cat/cupones_apl/CuponesAplComponent";
import CuponesAplFormComponent from "@/components/cat/cupones_apl/CuponesAplFormComponent";


import RptOfertasPromciones from "@/components/cat/Rpt_ofertas_promociones/RptOfertasPromciones";
import RptPreciosMInisoComponent from "@/components/cat/reportes/RptPreciosMInisoComponent";


export default [
  {
    path: "/cat/ofertas-promociones/",
    name: "cat-ofertas-promociones",
    component: RptOfertasPromciones,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/reportes/minisoprecios/",
    name: "cat-preciosminiso",
    component: RptPreciosMInisoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/cupones-apl/nuevo",
    name: "cat-cupones-apl-nuevo",
    component: CuponesAplComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/cupones-apl/crear",
    name: "cat-cupones-apl-crear",
    component: CuponesAplFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/cupones-apl/editar/:id/",
    name: "cat-cupones-apl-editar",
    component: CuponesAplFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/extensiones/",
    name: "cat-extensiones",
    component: ExtensionesReportComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/clientes/editar/:nit/",
    name: "cat-clientes-editar",
    component: ClienteFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/clientes/nuevo/",
    name: "cat-clientes-nuevo",
    component: ClienteFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/clientes",
    name: "cat-clientes",
    component: ClientesComponent,
    meta: {
      requiresAuth: true,
      permission: "list_cliente",
    },
  },
  {
    path: "/cat/superclientes/editar/:nit/",
    name: "cat-superclientes-editar",
    component: SuperClienteFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/superclientes/nuevo/",
    name: "cat-superclientes-nuevo",
    component: SuperClienteFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/superclientes",
    name: "cat-superclientes",
    component: SuperClientesComponent,
    meta: {
      requiresAuth: true,
      permission: "list_cliente",
    },
  },
  {
    path: "/cat/proveedores/nuevo",
    name: "cat-proveedores-nuevo",
    component: ProveedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/proveedores/editar/:id/",
    name: "cat-proveedores-editar",
    component: ProveedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios/",
    name: "cat-lista_precios",
    component: ListaPrecioListadoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios/nueva",
    name: "cat-lista_precios-nueva",
    component: ListaPrecioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios/editar/:id/",
    name: "cat-lista_precios-editar",
    component: ListaPrecioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios_productos/",
    name: "cat-lista_precios_productos",
    component: ListaPrecioListadoProductosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios_productos/nuevo/",
    name: "cat-lista_precios_productos-nuevo",
    component: EditarPreciosProductosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/lista_precios_productos/editar/:id/",
    name: "cat-lista_precios_productos-editar",
    component: EditarPreciosProductosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/proveedores",
    name: "cat-proveedores",
    component: ProveedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/productos/editar/:sku/",
    name: "cat-productos-editar",
    component: ProductosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/productos/:sku/precios",
    name: "cat-productos-precios",
    component: ProductosPreciosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/productos/:sku/precios-v2",
    name: "cat-productos-precios-v2",
    component: ProductosPreciosV2Component,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/cat/productos/",
    name: "cat-productos",
    component: ProductosComponent,
    meta: {
      requiresAuth: true,
      permission: "list_productos",
    },
  },
  {
    path: "/cat/productos/nuevo",
    name: "cat-productos-nuevo",
    component: ProductosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/tiendas/",
    name: "cat-tiendas",
    component: TiendasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/tiendas/nueva",
    name: "cat-tiendas-nueva",
    component: TiendasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/tiendas/editar/:id/",
    name: "cat-tiendas-editar",
    component: TiendasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/categorias/",
    name: "cat-categorias",
    component: CategoriasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/categorias/nueva",
    name: "cat-categorias-nueva",
    component: CategoriaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/categorias/editar/:id/",
    name: "cat-categorias-editar",
    component: CategoriaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/subcategorias/:categoria/",
    name: "cat-subcategorias",
    component: SubCategoriasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/subcategorias/:categoria/nueva",
    name: "cat-subcategorias-nueva",
    component: SubCategoriasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/subcategorias/:categoria/editar/:id/",
    name: "cat-subcategorias-editar",
    component: SubCategoriasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/unidades-medidas/",
    name: "cat-unidadesmedidas",
    component: UnidadesMedidasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/unidades-medidas/nueva",
    name: "cat-unidadesmedidas-nueva",
    component: UnidadesMedidasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/unidades-medidas/editar/:id/",
    name: "cat-unidadesmedidas-editar",
    component: UnidadesMedidasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/bancos/",
    name: "cat-bancos",
    component: BancosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/bancos/nuevo/",
    name: "cat-bancos-nuevo",
    component: BancosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/bancos/editar/:id/",
    name: "cat-bancos-editar",
    component: BancosFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/formas-pago/",
    name: "cat-formas-pago",
    component: FormaPagoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/formas-pago/nuevo/",
    name: "cat-formas-pago-nuevo",
    component: FormaPagoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/formas-pago/editar/:id/",
    name: "cat-formas-pago-editar",
    component: FormaPagoFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/cuentas-bancarias/",
    name: "cat-cuentas-bancarias",
    component: CuentasBancariasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/cuentas-bancarias/nuevo/",
    name: "cat-cuentas-bancarias-nuevo",
    component: CuentasBancariasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/cuentas-bancarias/editar/:id/",
    name: "cat-cuentas-bancarias-editar",
    component: CuentasBancariasFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/areas/",
    name: "cat-areas",
    component: AreaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/areas/nuevo/",
    name: "cat-areas-nuevo",
    component: AreaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/areas/editar/:id/",
    name: "cat-areas-editar",
    component: AreaFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/centro-costos/",
    name: "cat-centro-costos",
    component: CentroCostoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/centro-costos/nuevo/",
    name: "cat-centro-costos-nuevo",
    component: CentroCostoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/centro-costos/editar/:id/",
    name: "cat-centro-costos-editar",
    component: CentroCostoFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/tienda-bodega/",
    name: "cat-tienda-bodega",
    component: TiendaBodegaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/tienda-bodega/nuevo/",
    name: "cat-tienda-bodega-nuevo",
    component: TiendaBodegaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/tienda-bodega/editar/:id/",
    name: "cat-tienda-bodega-editar",
    component: TiendaBodegaFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cat/precios/",
    name: "cat-precios",
    component: PreciosComponent,
    meta: {
      requiresAuth: true,
      permission: "list_productos",
    },
  },
  {
    path: "/cat/precios/:sku/",
    name: "cat-precios-producto",
    component: PreciosComponent,
    meta: {
      requiresAuth: true,
      permission: "list_productos",
    },
  },
  {
    path: "/cat/habladores/",
    name: "cat-habladores",
    component: HabladoresHoyComponent,
    meta: {
      requiresAuth: true,
      permission: "list_productos",
    },
  },
  {
    path: "/cat/precios-actuales-dia/",
    name: "cat-precios-actuales-dia",
    component: PreciosActualizadosEnTabla,
    meta: {
      requiresAuth: true,
      permission: "list_productos",
    },
  },
  {
    path: "/cat/posiciones/",
    name: "cat-posiciones",
    component: PosicionesComponents,
    meta: {
      requiresAuth: true,
    },
  },  
  {
    path: "/cat/escalas/",
    name: "cat-escalas",
    component: EscalasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/escalas/nuevo/",
    name: "cat-escalas-nuevo",
    component: EscalasFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cat/escalas/editar/:id/",
    name: "cat-escalas-editar",
    component: EscalasFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
];
